import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {EMPTY_PLACEHOLDER_INSERTION_CONTEXT} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {ProcessTaskSchemaQuery} from 'processes/modals/__generated/ProcessTaskSchemaQuery';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

import {ProcessTableLocation} from '../ProcessConstants';
import ProcessOutputStructuredTableAdapter, {
  ProcessOutputStructuredTable,
} from './ProcessOutputStructuredTableAdapter';

type OutputSchema = NonNullable<
  ExtractByTypename<ProcessTaskSchemaQuery['processTaskSchema'], 'ProcessTaskSchemaNode'>['outputSchema']
>;

interface CreateOutputTableWithPlaceholderRowFromSchemaParams {
  name: string;
  outputSchema: OutputSchema;
  tableLocation: ProcessTableLocation;
  selectorsById: {[id: string]: SchemaFieldSelector};
  locked?: boolean;
}

export default function createOutputTableWithPlaceholderRowFromSchema({
  name,
  outputSchema,
  tableLocation,
  selectorsById,
}: CreateOutputTableWithPlaceholderRowFromSchemaParams): ProcessOutputStructuredTable {
  const adapter = getStructuredTableAdapters()[
    StructuredTableKind.PROCESS_OUTPUT
  ] as ProcessOutputStructuredTableAdapter;
  const createProps = {
    name,
    schemas: [{...outputSchema, columnGroup: null}],
    entryId: null,
    metadata: {tableLocation},
    selectorsById,
    structuredTableInsertionContext: EMPTY_PLACEHOLDER_INSERTION_CONTEXT,
  };
  const table = adapter.createTable(createProps);

  table.rows = [
    {
      ...adapter.getBlankRow({}, 0, table.columns),
      cells: table.columns.map(() => ({text: ''})),
      isFinalized: false,
      metadata: adapter.getBlankRowMetadata(table.metadata),
    },
  ];

  return adapter.prepareForPreview({...table, cid: `${outputSchema.id}-outputs`});
}
